import changeCart from './changeCart';
import getCart from './getCart';

const removeAddonLineItem = async (parentLineItemKey) => {
  try {
    const cart = await getCart();
    if (!cart?.items) return;

    const addonItem = await cart.items.find(item => item.properties._parentLineItemKey === parentLineItemKey);
    if (addonItem) {
      await changeCart(addonItem.key, 0);
    }
  } catch (err) {
    console.error('Error removing add-on line item:', err);
  }
};

export default removeAddonLineItem;
